import { AlcDrawer, DrawerTitle } from "../ui/drawer";
import ContainerSearch from "./ContainerSearch";
import ContainerTabs from "./ContainerTabs";

export default function ContainerDrawer({
  containerSelectionOpen,
  setContainerSelectionOpen,
  selection,
}) {
  return (
    <AlcDrawer
      isOpen={containerSelectionOpen}
      setIsOpen={setContainerSelectionOpen}
      header={
        <>
          <DrawerTitle style={{ paddingBottom: "1rem" }}>
            Výběr nádoby
          </DrawerTitle>
          <ContainerSearch
            open={containerSelectionOpen}
            setOpen={setContainerSelectionOpen}
          />
        </>
      }
    >
      <ContainerTabs
        selection={selection}
        open={containerSelectionOpen}
        setOpen={setContainerSelectionOpen}
      />
    </AlcDrawer>
  );
}
